import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../i18n/LanguageContext';

// Permissions & History Development Plan (13.10.2026), Phase 5 — "My
// Account": personal language preference (German/English). "It controls
// menu, Case Control, My Tasks, History and status labels. The language
// changes neither country assignment nor access rights" — this page only
// ever writes users.preferred_language, nothing else.
const ROLE_LABELS = {
  company_director: 'Company Director',
  super_admin: 'Super Admin',
  country_manager: 'Country Manager',
  support_agent: 'Support Agent',
  contractor: 'Contractor',
};

const MyAccount = () => {
  const { user, adminRole } = useAuth();
  const { language, setLanguage, t } = useLanguage();
  const [saving, setSaving] = useState(false);

  const choose = async (lang) => {
    if (lang === language || saving) return;
    setSaving(true);
    try {
      await setLanguage(lang);
      toast.success(lang === 'de' ? 'Sprache auf Deutsch geändert' : 'Language changed to English');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Could not save language preference');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={s.page}>
      <h1 style={s.h1}>{t('My account')}</h1>

      <div style={s.card}>
        <div style={s.row}><span style={s.label}>Name</span><span>{user?.full_name || '—'}</span></div>
        <div style={s.row}><span style={s.label}>Email</span><span>{user?.email}</span></div>
        <div style={s.row}><span style={s.label}>Role</span><span>{ROLE_LABELS[adminRole?.role_type] || '—'}</span></div>
      </div>

      <h2 style={s.h2}>Language</h2>
      <p style={s.hint}>
        Controls the menu, Case Control, My Tasks, History and status labels. It does not change your
        country access or permissions.
      </p>
      <div style={s.card}>
        <label style={s.radioLabel}>
          <input type="radio" name="language" checked={language === 'en'} disabled={saving} onChange={() => choose('en')} /> English
        </label>
        <label style={s.radioLabel}>
          <input type="radio" name="language" checked={language === 'de'} disabled={saving} onChange={() => choose('de')} /> Deutsch (German)
        </label>
      </div>
    </div>
  );
};

const s = {
  page: { padding: 24, maxWidth: 560 },
  h1: { fontSize: 22, fontWeight: 800, marginBottom: 16 },
  h2: { fontSize: 15, fontWeight: 800, marginTop: 24, marginBottom: 6, color: '#374151' },
  hint: { color: '#6b7280', fontSize: 13, marginBottom: 12 },
  card: { background: 'white', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, display: 'flex', flexDirection: 'column', gap: 10 },
  row: { display: 'flex', justifyContent: 'space-between', fontSize: 13.5, borderBottom: '1px solid #f3f4f6', paddingBottom: 8 },
  label: { color: '#6b7280' },
  radioLabel: { display: 'flex', alignItems: 'center', gap: 8, fontSize: 14 },
};

export default MyAccount;
